import { useIntl } from "react-intl";

import SimpleImageTextSide from "@/patterns/wpl/simple-image-text-side/src";

const AssignAndPrioritize = () => {
    const intl = useIntl();
    const title = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabSection.assignAndPrioritize.title",
        defaultMessage: "Prioritize bug by level of importance"
    });

    const bodyText = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabSection.assignAndPrioritize.listItem",
        defaultMessage:
            "Once bugs are captured, squash them in order based on the level of importance, urgency, and the team's capacity. Assign bugs with a few keystrokes and prioritize them by dragging and dropping them in your team's backlog or to-do column. By having a single source of truth, you can keep everyone on the same page and ensure the team is working on the highest priority items first."
    });
    const imageSrc =
        "https://wac-cdn-2.atlassian.com/dam/jcr:a217ffd9-2860-408f-afcd-6d57408b9c75/assign-and-prioritize2x.png?cdnVersion=ece";
    const imageAlt = "assign and prioritize Image";

    return (
        <SimpleImageTextSide
            headerText={title}
            bodyText={bodyText}
            imageLink={imageSrc}
            imageAltText={imageAlt}
            alignItems={"top"}
            rowProps="4-8"
            className="simple-image-text-side-tabs"
        />
    );
};

export default AssignAndPrioritize;
